import { render, staticRenderFns } from "./SpecGridRow.vue?vue&type=template&id=2866a296&"
import script from "./SpecGridRow.vue?vue&type=script&lang=js&"
export * from "./SpecGridRow.vue?vue&type=script&lang=js&"
import style0 from "./SpecGridRow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports